module.exports = __webpack_public_path__ + "img/2-2-bim.48d80e41.jpg";